"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistoryChanges = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const useHistoryChanges = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogChanges = (0, store_1.useCatalogChanges)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedStrategyNodePath = (0, store_1.useSelectedTreeNodePath)();
    const selectedStrategyNodeChanges = (0, react_1.useMemo)(() => { var _a; return (_a = catalogChanges === null || catalogChanges === void 0 ? void 0 : catalogChanges.filter(({ path }) => path.startsWith(selectedStrategyNodePath))) !== null && _a !== void 0 ? _a : []; }, [catalogChanges, selectedStrategyNodePath]);
    const handleAddNewItemsToHistory = (attribute, treeNodePaths) => {
        const historyItems = [];
        const { newValues = [], name, } = attribute;
        for (const valueItem of newValues) {
            for (const treeNodePath of treeNodePaths) {
                const historyItem = {
                    id: `${name}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${valueItem.name}`,
                    entityType: store_1.ChangeEntityType.Value,
                    actionType: store_1.ChangeActionType.Add,
                    path: treeNodePath,
                };
                historyItems.push(historyItem);
            }
        }
        dispatch((0, store_1.enrichAIAddChanges)(selectedCatalogId, historyItems));
    };
    const handleAddEditedItemsToHistory = (attribute, treeNodePaths) => {
        const historyItems = [];
        const { valuesWithNewGuideline = [], name, isDescriptionChanged, } = attribute;
        for (const treeNodePath of treeNodePaths) {
            for (const valueItem of valuesWithNewGuideline) {
                const historyItem = {
                    id: `${name}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${valueItem.name}`,
                    entityType: store_1.ChangeEntityType.Value,
                    actionType: store_1.ChangeActionType.Edit,
                    path: treeNodePath,
                };
                historyItems.push(historyItem);
            }
            if (isDescriptionChanged) {
                const historyItem = {
                    id: name,
                    entityType: store_1.ChangeEntityType.Attribute,
                    actionType: store_1.ChangeActionType.Edit,
                    path: treeNodePath,
                };
                historyItems.push(historyItem);
            }
        }
        dispatch((0, store_1.enrichAIAddChanges)(selectedCatalogId, historyItems));
    };
    return {
        selectedStrategyNodeChanges,
        catalogChanges,
        handleAddNewItemsToHistory,
        handleAddEditedItemsToHistory,
    };
};
exports.useHistoryChanges = useHistoryChanges;
